<template>

    <div class="col-12">
        <div v-if="errors">
            {{ errors }}
        </div>
        <form>

            <div class="row">
                <div class="form-search-wrap col-12">
                    <div class="choices-filter-group double">
                        <input @keyup="keyDownDebounce" type="text" name="keyword" id="keyword" placeholder="Enter a keyword, entry number, or title" v-model="query_keyword" >
                    </div>
                </div>

                <div class="col-3 pt-2 single">
                    <Select2 @change="fetchEntries" id="entry_panel_type" placeholder="Panel" v-model="entry_panel_type" :options="entry_panel_type_options" :settings="{ multiple: true, placeholder: 'Panels', width: '100%' }" ></Select2>
                </div>
                <div class="col-3 pt-2">
                  <Select2 @change="fetchEntries" id="entry_college" placeholder="School" v-model="query_entry_college" :options="entry_college_options" :settings="{ multiple: true, placeholder: 'Schools', width: '100%' }" ></Select2>
                </div>
                <div class="col-3 pt-2">
                  <Select2 @change="fetchEntries" id="entry_placement_status" placeholder="Placement Status" v-model="query_entry_placement_status" :options="entry_placement_status_options" :settings="{ multiple: true, placeholder: 'Placement Status', width: '100%' }" ></Select2>
                </div>
                <div class="col-2 offset-1 pt-2 ">
                    <a class="pull-right clear-button no-border cursor-pointer h-100 d-flex align-items-center" v-on:click.stop="clearSearch()"><i class="fa fa-times"></i>Clear Search</a>
                </div>
            </div>

        </form>
        <br/>

        <div class="entries-table-wrap">
          <table id="sortable-table" class="nice-table">
            <thead>

            <tr class="tableHeaderRow">
              <th class="cursor-pointer th-entry th-100" v-on:click="setSort('entry_id')">ID <i v-if="sort == 'entry_id'" class="fa cursor-pointer" :class="(sort_order != 'desc') ? 'fa-caret-up' : 'fa-caret-down'"></i></th>
              <th class="cursor-pointer th-submitter th-150" v-on:click="setSort('last_name')">Submitter <i class="fa cursor-pointer" v-if="sort == 'last_name'" :class="(sort_order != 'desc') ? 'fa-caret-up' : 'fa-caret-down'"></i></th>
              <th class="cursor-pointer th-title" v-on:click="setSort('title')">Title <i class="fa cursor-pointer" v-if="sort == 'title'" :class="(sort_order != 'desc') ? 'fa-caret-up' : 'fa-caret-down'"></i></th>
              <th class="cursor-pointer th-category th-150" v-on:click="setSort('category_name')">Category <i class="fa cursor-pointer" v-if="sort == 'category_name'" :class="(sort_order != 'desc') ? 'fa-caret-up' : 'fa-caret-down'"></i></th>
              <th class="cursor-pointer th-school" v-on:click="setSort('college_value')">School <i class="fa cursor-pointer" v-if="sort == 'college_value'" :class="(sort_order != 'desc') ? 'fa-caret-up' : 'fa-caret-down'"></i></th>
              <th class="cursor-pointer th-name th-110" v-on:click="setSort('panel')">Panel <i class="fa cursor-pointer" v-if="sort == 'panel'" :class="(sort_order != 'desc') ? 'fa-caret-up' : 'fa-caret-down'"></i></th>
            </tr>
            </thead>
            <tbody v-for="(entry,i) in entries.data" >
            <tr>
              <td class="" @click="loadEntry(entry.entry_id)"><div class="cursor-pointer">{{ entry.entry_id }}</div></td>
              <td @click="loadEntry(entry.entry_id)"><div class="cursor-pointer">{{ entry.first_name + ' ' + entry.last_name }}</div></td>
              <td @click="loadEntry(entry.entry_id)"><div class="cursor-pointer word-break">{{ entry.title }}</div></td>
              <td @click="loadEntry(entry.entry_id)"><div class="cursor-pointer">{{ entry.category.name }}</div></td>
              <td @click="loadEntry(entry.entry_id)"><div class="cursor-pointer" v-html="entrantCollege(entry.entrants)">
              </div></td>
              <td @click="loadEntry(entry.entry_id)"><div class="cursor-pointer">{{ key_value_panels[entry.panel] }}</div></td>
            </tr>
            </tbody>
          </table>
        </div>
        <div style="float:right;">
            <pagination :data="entries" @pagination-change-page="paginationCalculator" :limit="3">
                <span slot="prev-nav">&lt; Previous</span>
                <span slot="next-nav">Next &gt;</span>
            </pagination>
        </div>
        <div class="dataTables_info" v-if="to">Showing 1-{{to}} of {{ total }} entries</div>
        <div class="dataTables_info" v-else>Showing 0 entries</div>
        <div class="dataTables_length admin-entry-table">
            <label>
                <span>Show</span>
                <select class="plain-select num-entries-select" v-model="num" @change="fetchEntries">
                    <option value="10">10 Entries</option>
                    <option value="20">20 Entries</option>
                    <option value="50">50 Entries</option>
                    <option value="100">100 Entries</option>
                    <option value="all">All Entries</option>
                </select>
                <span>per page</span>
            </label>
        </div>

    </div>
</template>


<script>
import checkmark from "../components/icons/checkmark.vue";
import closeicon from "../components/icons/close.vue";
import file from "../components/icons/file.vue";
import play from "../components/icons/play.vue";
import email from "../components/icons/email.vue";
import modal from "../components/Modal.vue";
import flash_alert from "../components/FlashAlert.vue";
import {forEach} from "lodash";

export default {
  name: "MarketingSearch",
  components: {file, checkmark, closeicon, play, email, modal, flash_alert},
  props: ['panels', 'key_value_panels', 'universities', 'all_universities_key_value'],
  data() {
    return {
      errors: false,
      num:20,
      page:1,
      total: 0,
      to: 0,
      sort:'',
      sort_order: 'desc',
      entries: {},
      query_keyword: (localStorage.getItem('CTA-marketing-history-search') != null) ? localStorage.getItem('CTA-marketing-history-search') : '',
      query_entry_status: (localStorage.getItem('CTA-marketing-history-search-status') != null) ? localStorage.getItem('CTA-marketing-history-search-status') : '',
      query_entry_placement_status: (localStorage.getItem('CTA-marketing-history-search-placement-status') != null) ? localStorage.getItem('CTA-marketing-history-search-placement-status') : '',
      entry_panel_type: (localStorage.getItem('CTA-marketing-history-entry-panel') != null) ? localStorage.getItem('CTA-marketing-history-entry-panel') : '',
      query_has_video: (localStorage.getItem('CTA-marketing-history-has-video') != null) ? localStorage.getItem('CTA-marketing-history-has-video') : 0,
      query_video_status: (localStorage.getItem('CTA-marketing-history-search-filestatus') != null) ? localStorage.getItem('CTA-marketing-history-search-filestatus') : '',
      query_entry_college: (localStorage.getItem('CTA-marketing-history-entry-college') != null) ? localStorage.getItem('CTA-marketing-history-entry-college') : '',
      entry_panel_type_options: this.panels,
      entry_college_options: this.universities,
      entry_status_options: [{
        text: "In Progress",
        id: "in_progress"
      }, {
        text: "Under Faculty Review",
        id: "under_faculty_review"
      }, {
        text: "Canceled",
        id: "canceled"
      }, {
        text: "Need More Information",
        id: "need_more_info"
      }, {
        text: "Faculty Approved",
        id: "faculty_approved"
      }, {
        text: "Ready For Ballot",
        id: "ready_for_ballot"
      }],
      entry_placement_status_options: [
        'Nominee',
        'Winner'
      ],
      video_status_options: [
        'Upload Successful',
        'Under Review',
        'Need More Info',
        'Video Approved',
      ],
      slideUpClass: '',
      selectedEntryIds: [],
      numEntriesSelected: 0,
    }
  },
  mounted() {
    if(localStorage.getItem('CTA-marketing-history-search-sort')) {
      this.sort = localStorage.getItem('CTA-marketing-history-search-sort');
    }
    if(localStorage.getItem('CTA-marketing-history-search-sort-order')) {
      this.sort_order = localStorage.getItem('CTA-marketing-history-search-sort-order');
    }
    if(localStorage.getItem('CTA-marketing-history-search-num')) {
      this.num = localStorage.getItem('CTA-marketing-history-search-num');
    }
    if(localStorage.getItem('CTA-marketing-history-search-page')) {
      this.page = localStorage.getItem('CTA-marketing-history-search-page');
    }
    if(localStorage.getItem('CTA-marketing-history-entry-panel')) {
      let judgingStatus = localStorage.getItem('CTA-marketing-history-entry-panel');
      this.entry_panel_type = judgingStatus.split(',');
    }
    if(localStorage.getItem('CTA-marketing-history-entry-college')) {
      let judgingStatus = localStorage.getItem('CTA-marketing-history-entry-college');
      this.query_entry_college = judgingStatus.split(',');
    }
    if(localStorage.getItem('CTA-marketing-history-search-status')) {
      var searchStatus = localStorage.getItem('CTA-marketing-history-search-status');
      this.query_entry_status = searchStatus.split(',');
    }
    if(localStorage.getItem('CTA-marketing-history-search-placement-status')) {
      var searchPlacementStatus = localStorage.getItem('CTA-marketing-history-search-placement-status');
      this.query_entry_placement_status = searchPlacementStatus.split(',');
    }
    if(localStorage.getItem('CTA-marketing-history-search-filestatus')) {
      var searchFileStatus = localStorage.getItem('CTA-marketing-history-search-filestatus');
      this.query_video_status = searchFileStatus.split(',');
    }
    if(localStorage.getItem('CTA-marketing-history-has-video')) {
      this.query_has_video = localStorage.getItem('CTA-marketing-history-has-video') == "true";
    }
    this.fetchEntries(this.page);
  },
  methods:{
    keyDownDebounce() {
      clearTimeout(this.timeout);
      var app = this;
      this.timeout = setTimeout(function () {
        console.log('searching:', app.query_keyword);
        app.fetchEntries()
      }, 300);
    },
    entryStatusHumanReadable(inputStatus) {

      switch(inputStatus) {
        case 'in_progress':
          return 'In Progress';
        case 'under_faculty_review':
          return 'Under Faculty Review';
        case 'faculty_approved':
          return 'Faculty Approved';
        case 'need_more_info':
          return 'Need More Info';
        case 'ready_for_ballot':
          return 'Ready For Ballot';
        default:
          return inputStatus;
      }
    },
    videoStatusHumanReadable(inputStatus) {

      switch(inputStatus) {
        case 'Published':
          return 'Upload Successful';
        default:
          return inputStatus;
      }
    },
    loadEntry(entry_id){
      window.location = '/entry/'+entry_id;
    },
    fetchEntries(page = 1){
      let app = this;
      axios.get('/api/entries', {
        params: {
          num: app.num,
          page: page,
          sort: app.sort,
          sort_order: app.sort_order,
          keyword: app.query_keyword,
          entry_status: app.query_entry_status,
          placement_status: app.query_entry_placement_status,
          college: app.query_entry_college,
          video_status: app.query_video_status,
          has_video: app.query_has_video,
          panel: app.entry_panel_type,
        }
      })
          .then(res => {
            app.entries = res.data;
            app.total = res.data.total;
            app.to = res.data.to;
            localStorage.setItem('CTA-marketing-history-search-to', app.to);
            localStorage.setItem('CTA-marketing-history-search', app.query_keyword);
            localStorage.setItem('CTA-marketing-history-search-status', app.query_entry_status);
            localStorage.setItem('CTA-marketing-history-search-placement-status', app.query_entry_placement_status);
            localStorage.setItem('CTA-marketing-history-search-status', app.query_entry_college);
            localStorage.setItem('CTA-marketing-history-search-filestatus', app.query_video_status);
            localStorage.setItem('CTA-marketing-history-has-video', app.query_has_video);
            localStorage.setItem('CTA-marketing-history-search-num', app.num);
            localStorage.setItem('CTA-marketing-history-entry-panel', app.entry_panel_type);
            let entryIdList = _.map(app.entries.data, 'entry_id')
            localStorage.setItem('CTA-marketing-next-prev', entryIdList);
          }).catch(err => {
        let errorMessage = err.response.status + ' status error';
        app.$parent.$refs.flash_alert.activateFlashAlert(errorMessage, 'error');
      });
    },
    setSort(sort) {
      if (this.sort == sort) {
        this.sort_order = (this.sort_order == 'desc')?'asc':'desc';
      } else {
        this.sort = sort;
        this.sort_order = 'desc';
      }
      localStorage.setItem('CTA-marketing-history-search-sort', this.sort);
      localStorage.setItem('CTA-marketing-history-search-sort-order', this.sort_order);
      this.fetchEntries();
    },
    clearSearch: function() {
      this.query_keyword = '';
      this.sort = '';
      this.sort_order = 'desc';
      this.num = 20;
      this.query_entry_status = '';
      this.query_entry_placement_status = '';
      this.query_entry_college = '';
      this.entry_panel_type = '';
      this.query_video_status = '';
      this.query_has_video = false;
      localStorage.removeItem('CTA-marketing-history-search');
      localStorage.removeItem('CTA-marketing-history-search-status');
      localStorage.removeItem('CTA-marketing-history-search-placement-status');
      localStorage.removeItem('CTA-marketing-history-search-filestatus');
      localStorage.removeItem('CTA-marketing-history-search-type');
      localStorage.removeItem('CTA-marketing-history-search-sort');
      localStorage.removeItem('CTA-marketing-history-search-sort-order');
      localStorage.removeItem('CTA-marketing-history-search-num');
      localStorage.removeItem('CTA-marketing-history-search-page');
      localStorage.removeItem('CTA-marketing-history-has-video');
      localStorage.removeItem('CTA-marketing-history-entry-panel');
      this.fetchEntries()
    },
    paginationCalculator: function(pageIndex) {
      localStorage.setItem('CTA-marketing-history-search-page', pageIndex);
      this.fetchEntries(pageIndex);
    },
    entrantCollege(entrants) {
      let collegeOutput = '';
      let collegesUsed = [];
      forEach(entrants, function(entrant, i) {
        if((entrant.college != null) && (!collegesUsed.includes(entrant.college))) {
          collegesUsed.push(entrant.college);
          collegeOutput += entrant.college_value + '<br>';
        }
      })
      return collegeOutput;
    }
  },
  watch: {
    num() {
      this.page = 1;  // Reset to first page when number of items changed
    },
  }
}
</script>

